import { render, staticRenderFns } from "./modal-approval-payment.vue?vue&type=template&id=4562f7ae&"
import script from "./modal-approval-payment.vue?vue&type=script&lang=js&"
export * from "./modal-approval-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports